<template>
  <div v-if="currentChecklist && currentQuestion">
    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary"
          @click.prevent="
            $router
              .push({
                name: baseUrl,
                params: { id: id },
              })
              .catch(() => {})
          "
        >
          Liste des questions
        </button>
        <NewQuestionButton class="ml-4" :currentChecklist="currentChecklist" />
        <button
          type="button"
          class="btn btn-custom-primary ml-4"
          style="min-width: 100px"
          @click.prevent="
            $router
              .push({
                name: baseUrl + '-edit',
                params: {
                  id: currentChecklist.id,
                  questionUuid: questionUuid,
                  type: getQuestionTypeCodeUrl(
                    currentQuestion.questionable_type
                  ),
                },
              })
              .catch(() => {})
          "
        >
          <i class="fas fa-edit"></i> Modifier
        </button>
      </div>
    </div>
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive bg-white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold">
                      Libellé de la question</span
                    >
                  </td>
                  <td>
                    <p v-html="currentQuestion.libelle"></p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentQuestion.created_by.prenom
                        ? currentQuestion.created_by.prenom +
                          ' ' +
                          currentQuestion.created_by.nom
                        : currentQuestion.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive bg-white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Statut</span>
                  </td>
                  <td>
                    <b-badge
                      variant="custom-primary"
                      pill
                      v-if="currentQuestion.statut"
                      class="p-2"
                    >
                      Oui
                    </b-badge>
                    <b-badge variant="danger" pill v-else class="p-2">
                      Non
                    </b-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/rh/entretien/checklist-question';
import NewQuestionButton from '../NewQuestionButton.vue';
export default {
  data() {
    return {
      currentQuestion: null,
    };
  },
  computed: {
    baseUrl() {
      return this.$route.name.split('-')[0];
    },
  },
  components: {
    NewQuestionButton,
  },
  methods: {
    init() {
      this.id = this.$route.params.id;
      this.questionUuid = this.$route.params.questionUuid;

      window.axios
        .get(URL.QL + '/' + this.questionUuid)
        .then((resp) => {
          this.currentQuestion = resp.data.question;
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
  props: ['currentChecklist'],
};
</script>

<style scoped></style>
